import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Select from "react-select";
import axios from "axios";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import swal from "sweetalert";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@material-ui/core/Button";
import { api_path } from "../../shared.js";
function MainContactForm(props) {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const userId = JSON.parse(localStorage.getItem("USER_ID"));
  const token = process.env.REACT_APP_API_TOKEN;
  const [leadId, setLeadId] = useState("");
  const [contactName, setContactName] = useState("");
  const [getAddress, setAddress] = useState("");
  const [getProvince, setProvince] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [company, setCompany] = useState("");
  const [sourceId, setSourceId] = useState("");
  const [getSource, setSource] = useState([]);
  const [getSourceList, setSourceList] = useState([]);
  const [getSelectSource, setSelectedSource] = useState([]);
  const [getStatusList, setStatusList] = useState([]);
  const [getSelectStatus, setSelectedStatus] = useState([]);
  const [getStatus, setStatus] = useState([]);
  const [statusId, setStatusId] = useState("");
  const [salesId, setSalesId] = useState("");
  const [getNote, setNote] = useState("");

  const fetchLeadStatus = () => {
    axios
      .get(`${api_path}/customer/leads-master.php?type=LEAD_STATUS`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setStatusList(response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleStatusChange = (obj) => {
    setSelectedStatus(obj.LEAD_MASTER_VALUE);
    setStatus({
      LEAD_MASTER_VALUE: obj.LEAD_MASTER_VALUE,
      LEAD_MASTER_EN: obj.LEAD_MASTER_EN,
    });
  };
  const fetchSourceStatus = () => {
    axios
      .get(`${api_path}/customer/leads-master.php?type=LEAD_SOURCE`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setSourceList(response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleSourceChange = (obj) => {
    setSelectedSource(obj.LEAD_MASTER_VALUE);
    setSource({
      LEAD_MASTER_VALUE: obj.LEAD_MASTER_VALUE,
      LEAD_MASTER_EN: obj.LEAD_MASTER_EN,
    });
  };
  useEffect(() => {
    fetchLeadStatus();
    fetchSourceStatus();
    if (props.CUSTOMER_CODE > 0) {
      fetch(api_path + "/customer/customers.php?id=" + props.CUSTOMER_CODE)
        .then((res) => res.json())
        .then((res) => {
          //console.log(res);
          const array = res;
          for (const i of array) {
            // SET_CUSTOMER_CODE(i.CRM_CUSCODE);
            // SET_CUSTOMER_NAME(i.CUSTOMER_NAME);
            // SET_CONTACT_NAME(i.CONTACT_NAME);
            // SET_CUSTOMER_ADDRESS(i.ADDRESS);
            // SET_CUSTOMER_EMAIL(i.ADDRESS);
            // SET_CUSTOMER_TAX_ID(i.TAX_ID);
            // SET_WEBSITE(i.WEBSITE);
          }
        });
    } else {
      // SET_CUSTOMER_CODE("");
      // SET_CUSTOMER_NAME("");
      // SET_CONTACT_NAME("");
      // SET_CUSTOMER_ADDRESS("");
      // SET_CUSTOMER_EMAIL("");
      // SET_CUSTOMER_TAX_ID("");
      // SET_WEBSITE("");
    }
  }, []);

  const handleSubmit = (event) => {
    //alert("ok")
    event.preventDefault();
    var data = {
      LEAD_ID: 0,
      CONTACT_NAME: contactName,
      CONTACT_EMAIL: contactEmail,
      CONTACT_PHONE: contactPhone,
      COMPANY: company,
      SOURCE_ID: getSelectSource,
      STATUS_ID: getSelectStatus,
      SALES_ID: salesId,
      USERID: userId,
    };
    console.log("Payload to PHP:", data); // ดู JSON ที่จะส่ง
    fetch(api_path + "/customer/leads.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          swal("Done.", "Save data successfully.", "success", {
            buttons: true,
            timer: 1000,
          }).then(function () {
            window.location = "./leads";
          });
        } else {
          swal("Sorry", result["message"], "error", {
            buttons: true,
            timer: 10000,
          });
        }
      });
  };

  return (
    <Grid item xs={12} sm={12}>
      <form onSubmit={handleSubmit}>
        <Grid container className="Box" spacing={2}>
          <Grid item xs={12} sm={6}>
            <label>ID</label>
            <TextField
              size="small"
              name="leadId"
              variant="outlined"
              fullWidth
              id="leadId"
              value={leadId}
              onChange={(e) => setLeadId(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>CONTACT NAME</label>
            <span className="red">*</span>
            <TextField
              size="small"
              name="contactName"
              variant="outlined"
              fullWidth
              id="contactName"
              value={contactName}
              onChange={(e) => setContactName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>EMAIL</label>
            <span className="red">*</span>
            <TextField
              size="small"
              name="contactEmail"
              variant="outlined"
              required
              fullWidth
              id="contactEmail"
              value={contactEmail}
              onChange={(e) => setContactEmail(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <label>PHONE</label>
            <span className="red">*</span>
            <TextField
              size="small"
              name="contactPhone"
              variant="outlined"
              required
              fullWidth
              id="contactPhone"
              value={contactPhone}
              onChange={(e) => setContactPhone(e.target.value)}
            />
          </Grid>

          {/* <Grid item xs={12} sm={12}>
            <label>ADDRESS</label>
            <span className="red">*</span>
            <TextField
              size="small"
              name="getAddress"
              variant="outlined"
              fullWidth
              id="getAddress"
              value={getAddress}
              onChange={(e) => setAddress(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>PROVINCE</label>
            <span className="red">*</span>
            <TextField
              size="small"
              name="getProvince"
              variant="outlined"
              fullWidth
              id="getProvince"
              value={getProvince}
              onChange={(e) => setProvince(e.target.value)}
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <label>SALES</label>
            <span className="red">*</span>
            <Select
              placeholder="Select..."
              value={getStatus}
              options={getStatusList}
              onChange={handleStatusChange}
              getOptionLabel={(x) => x.LEAD_MASTER_EN}
              getOptionValue={(x) => x.LEAD_MASTER_VALUE}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>SOURCE</label>
            <span className="red">*</span>
            <Select
              placeholder="Select..."
              value={getSource}
              options={getSourceList}
              onChange={handleSourceChange}
              getOptionLabel={(x) => x.LEAD_MASTER_EN}
              getOptionValue={(x) => x.LEAD_MASTER_VALUE}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>STATUS</label>
            <span className="red">*</span>
            <Select
              placeholder="Select..."
              value={getStatus}
              options={getStatusList}
              onChange={handleStatusChange}
              getOptionLabel={(x) => x.LEAD_MASTER_EN}
              getOptionValue={(x) => x.LEAD_MASTER_VALUE}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>TAG</label>
            <span className="red">*</span>
            <Select
              placeholder="Select..."
              value={getSource}
              options={getSourceList}
              onChange={handleSourceChange}
              getOptionLabel={(x) => x.LEAD_MASTER_EN}
              getOptionValue={(x) => x.LEAD_MASTER_VALUE}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <label>Comment</label>
              <TextField
                                size="small"
                                name="getNote"
                                variant="outlined"
                                fullWidth
                                id="getNote"
                                value={getNote}
                                onChange={(e) => setNote(e.target.value)}
                                multiline
                                rows={4}
                              />
           
         
          </Grid>
        </Grid>
{/* 
        <Grid container className="Box" spacing={2}>
       
          <Grid item xs={12} sm={12}>
            <Button type="submit" fullWidth variant="contained" color="primary">
              Save
            </Button>
          </Grid>
        </Grid> */}

        



                {/* <Grid container className="Box" spacing={2}>
          <Grid item xs={12} sm={3}>
            <Button
              type="button"
              fullWidth
              variant="outlined"
              color="primary"
              onClick={goBack}
            >
              New Activities
            </Button>
          </Grid>
            <Grid item xs={12} sm={3}>
            <Button
              type="button"
              fullWidth
              variant="outlined"
              color="primary"
              onClick={goBack}
            >
              &larr; Go Back
            </Button>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Button type="submit" fullWidth variant="contained" color="primary">
              Save
            </Button>
          </Grid>
        </Grid> */}
      </form>
    </Grid>
  );
}

export default MainContactForm;
